// extracted by mini-css-extract-plugin
module.exports = {"page":"_3914","hd":"_16332"};